import React from 'react';
import Chart from 'react-apexcharts';

const AnalyticCard = ({
  selectedWidget,
  selectWidget,
  ttlImpcnt,
  arrWidgetDt,
  arrWidgetCnt
}) => {
  let multiLineCht = {
    colors: ['#2dca73'],
    chart: {
      dropShadow: {
        enabled: true,
        enabledOnSeries: undefined,
        top: 15,
        left: 2,
        blur: 3,
        color: ['#2dca73'],
        opacity: 0.15
      },
      toolbar: {
        tools: {
          download: false
        }
      }
    },

    stroke: {
      curve: 'smooth',
      width: 4
    },
    markers: {
      size: 0
    },
    xaxis: {
      categories: arrWidgetDt,
      type: 'datetime'
    },
    grid: {
      show: true,
      borderColor: '#ECEEF4',
      strokeDashArray: 0,
      position: 'back',
      xaxis: {
        lines: {
          show: true
        }
      },
      row: {
        colors: ['#fff', '#fff'],
        opacity: 0.1
      },
      column: {
        colors: ['#fff', '#fff'],
        opacity: 0.1
      },
      padding: {
        top: 0,
        right: 0,
        bottom: -10,
        left: 0
      },
    },
    legend: {
      position: 'top',
      itemMargin: {
        vertical: 15
      },
    }
  };

  // let options = {
  //   chart: {
  //     dropShadow: {
  //       enabled: true,
  //       enabledOnSeries: undefined,
  //       top: 3,
  //       left: 2,
  //       blur: 3,
  //       color: '#35cc78',
  //       opacity: 0.2
  //     },
  //     toolbar: {
  //       tools: {
  //         download: false
  //       }
  //     }
  //   },
  //   dataLabels: {
  //     enabled: false
  //   },
  //   stroke: {
  //     curve: 'smooth',
  //     width: 3
  //   },
  //   xaxis: {
  //     floating: true,
  //     axisTicks: {
  //       show: false
  //     },
  //     axisBorder: {
  //       show: false
  //     },
  //     labels: {
  //       show: false
  //     },
  //     tooltip: {
  //       enabled: false
  //     },
  //     categories: arrWidgetDt
  //   },
  //   floating: true,

  //   axisTicks: {
  //     show: false
  //   },
  //   axisBorder: {
  //     show: false
  //   },
  //   labels: {
  //     show: false
  //   },
  //   grid: {
  //     show: false,
  //     borderColor: '#35cc78',
  //     strokeDashArray: 0,
  //     position: 'back',
  //     xaxis: {
  //       lines: {
  //         show: false
  //       }
  //     },
  //     yaxis: {
  //       lines: {
  //         show: false
  //       }
  //     },
  //     row: {
  //       colors: undefined,
  //       opacity: 0.5
  //     },
  //     column: {
  //       colors: undefined,
  //       opacity: 0.5
  //     },
  //     padding: {
  //       top: 0,
  //       right: 0,
  //       bottom: -10,
  //       left: 0
  //     },
  //   },
  //   colors: ['#35cc78'],
  // };

  let seriesData = [
    {
      name: 'Impressions',
      data: arrWidgetCnt
    }
  ];
  return (
    <div className="analyticModel-body">
      <div className="analyticModel-hdr">
        <div className="applications-icon applications-icon-sm app-icon-brand-bg ">
          <img src={selectedWidget.iu} alt="icon" />
        </div>
        <h3>{selectedWidget.dn}</h3>
        <p>{selectWidget} analytic </p>
      </div>
      <div className="card card-ana-default card-ana-totalvisitor mb-30">
        <div className="card-analytic-count">
          <div className="analytic-count-top">
            <h4>Total Impressions</h4>
          </div>
          <span>{ttlImpcnt}</span>
        </div>
        {/* <div className="chart-unique-visitor">
          <Chart options={options} series={seriesData} type="area" height="80px" width="250px" />
        </div> */}
      </div>
      <div className="card card-ana-default card-ana-dayvisitor">
        {arrWidgetCnt.length > 0 &&
          <Chart options={multiLineCht} series={seriesData} type="line" width="100%" height="420px" />
        }
      </div>
    </div>
  );
};

export default AnalyticCard;


// WEBPACK FOOTER //
// ./src/components/Widget/AnalyticCard.js